import { createFileRoute } from '@tanstack/react-router'
import { EvaluationJobs } from '@/features/admin/evaluation-jobs'

export const Route = createFileRoute('/_authenticated/admin/evaluation-jobs')({
  component: EvaluationJobs,
})
